<template>
    <Page class="view-library-models">

        <State 
            :isLoading="isLoading" 
            :isEmpty="isEmpty" 
            subject="models">

            <AssetListScrollable  
                :list="models" 
                :context="true" 
                :overflow="true" 
                @select="handleSelect" />

        </State>

    </Page>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AssetListScrollable from '@/components/common/asset/AssetListScrollable.vue'
import State from '@/components/common/state/State.vue'
import Page from '@/components/library/page/Page.vue'

export default {
    name: 'ViewLibraryModels',
    components: {
        AssetListScrollable,
        State,
        Page
    },
    computed: {
        ...mapGetters('assets', [
            'isSynchronized'
        ]),
        ...mapGetters('library', [
            'getFilteredModelAssets'
        ]),
        isLoading() {
            return !this.isSynchronized
        },
        isEmpty() {
            return !Array.isArray(this.models) || this.models.length === 0
        },
        models() {
            return this.getFilteredModelAssets
        },
    },
    methods: {
        ...mapActions('windows', [
            'open'
        ]),
        handleSelect(asset) {
            this.open({ 
                component: "asset", 
                payload: { 
                    asset 
                } 
            })
        }
    }
}
</script>